module.exports = __webpack_public_path__ + "static/media/logo-25.e85df781.svg";